'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.validatePageName = validatePageName;

var _page_names_whitelist = require('./constants/page_names_whitelist.json');

var _page_names_whitelist2 = _interopRequireDefault(_page_names_whitelist);

var _legacy_page_names_whitelist = require('./constants/legacy_page_names_whitelist.json');

var _legacy_page_names_whitelist2 = _interopRequireDefault(_legacy_page_names_whitelist);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var validPageNames = new Set(_page_names_whitelist2.default);
var legacyPageNameWhitelist = new Set(_legacy_page_names_whitelist2.default);

function validatePageName(pageName) {
  if (legacyPageNameWhitelist.has(pageName)) {
    console.warn('Deprecation warning: the page name, "' + pageName + '", has been deprecated. For more information: https://github.move.com/ConsumerTech/rdc-tracking#console-warnings');
    return false;
  }
  if (!validPageNames.has(pageName)) {
    console.warn('Warning: "' + pageName + '" is not a recognized page name value. Please update the whitelist in rdc-tracking. For more information: https://github.move.com/ConsumerTech/rdc-tracking#console-warnings');
    return false;
  }
  return true;
}


//////////////////
// WEBPACK FOOTER
// /data/app/rdc-next/~/@moveinc/rdc-tracking/distribution/validate.js
// module id = 991
// module chunks = 48 49 50